import { createContext } from "react";

export type CanvasNavigationTool = "select" | "pan";

/** Local camera interaction only; never persisted to the shared document. */
export const CanvasNavigationContext = createContext<{
  tool: CanvasNavigationTool;
  selectTool: (tool: CanvasNavigationTool) => void;
} | null>(null);
